<h1 mat-dialog-title>Your Registry Exam has not been completed</h1>
<div mat-dialog-content>
  <div>
    <div>{{examMessage}}</div>
  </div>
  <div mat-dialog-actions>
    <button class="form-execute-buttons" type="button" color="primary" mat-raised-button (click)="confirmDialogOption('yes')">Visit exam page</button>
    <button class="form-execute-buttons" type="button" color="primary" mat-raised-button (click)="confirmDialogOption('cancel')">Cancel</button>
  </div>
</div>
